import { Routes } from '@angular/router';
import {LoginComponent} from './core/pages/login/login.component';
import {RegisterComponent} from './core/pages/register/register.component';
import {NonAuthGuard} from './core/guards/non-auth.guard';
import {RegisterSuccessComponent} from './core/pages/register-success/register-success.component';
import {AuthGuard} from './core/guards/auth.guard';
import {NonSubscriberGuard} from './core/guards/non-subscriber.guard';
import {PasswordReset} from './core/pages/password-reset/password-reset';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'reset-password',
    component: PasswordReset,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'register/success',
    component: RegisterSuccessComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [NonSubscriberGuard]
  },
  {
    path: 'blog',
    loadChildren: () =>
      import('./blog/blog.module').then(m => m.BlogModule),
  },
  {
    path: 'manage',
    loadChildren: () =>
      import('./creator/creator.module').then(m => m.CreatorModule),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then(m => m.AdminModule),
  },
  { path: '',
    loadChildren: () =>
      import('./marketplace/marketplace.module').then(m => m.MarketplaceModule),
  },
  { path: '**', redirectTo: 'marketplace'}
];
